import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { IconButton } from "@mui/material";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import HelpTextContainer from "../RepPerformance/GenericScorecard/BalancedScorecard/HelpTextContainer";
import BackToRcc from "../RevenueCommandCenter/BackToRcc";

const AddHeaderDescriptionWithHelperText = ({
  header,
  description,
  helperTextCharts,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const matchedHelpItem = helperTextCharts?.find(
    (it) => it.Chart_Name === header && it.URL_for_Help_Doc
  );

  const showHelp = Boolean(matchedHelpItem?.URL_for_Help_Doc);

  return (
    <Grid item xs={12} style={{ marginBottom: 20 }}>
      <BackToRcc />
      <Grid container justifyContent="center" alignItems="center" spacing={1}>
        <Grid item>
          <Typography variant="h2" align="center" data-test = {'DashboardName'}>
            {header}
          </Typography>
        </Grid>
        {showHelp && (
          <Grid item>
            <IconButton onClick={handleOpen} aria-label="help" size="medium">
              <HelpOutlineIcon fontSize="inherit" />
            </IconButton>
          </Grid>
        )}
      </Grid>

      <Typography variant="body1" align="center" data-test = {'Description'}>
        {description}
      </Typography>

      {showHelp && open && (
        <Grid container item justifyContent="flex-end">
          <HelpTextContainer
            open={open}
            handleClose={handleClose}
            helpTextFile={matchedHelpItem.URL_for_Help_Doc}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AddHeaderDescriptionWithHelperText;
